import SvgIcon from '@mui/material/SvgIcon';
import React from 'react';

import { petrol } from '../../../styles/mui/colors';

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconSurroundingsCourtComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest}>
      <svg
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M3 4h9l1 7" fill="none" />
        <path d="M4 11V4" fill="none" />
        <path d="M8 10V4" fill="none" />
        <path d="M18 5c-.6 0-1 .4-1 1v5.6" fill="none" />
        <path d="m10 11 11 .9c.6 0 .9.5.8 1.1l-.8 5h-1" fill="none" />
        <circle cx="7" cy="15" fill="none" r=".5" />
        <circle cx="7" cy="15" fill="none" r="5" />
        <path d="M16 18h-5" fill="none" />
        <circle cx="18" cy="18" fill="none" r="2" />
      </svg>
    </SvgIcon>
  );
};

IconSurroundingsCourtComponent.displayName = 'IconSurroundingsCourt';

const IconSurroundingsCourt = React.memo(IconSurroundingsCourtComponent);

export default IconSurroundingsCourt;
